import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "@app/store";
import { PARAMS } from "@constants/index";
import { FilterParams } from "types";
import { toast } from "react-toastify";
import { useDeleteFaqMutation, useLazyGetFaqsQuery } from "@modules/faq";
import { setFaqs } from "@modules/faq/store/faq.slice";

export const useFaqListLogic = () => {
  const dispatch = useAppDispatch();
  const faqList = useAppSelector((state) => state.faq.faqs)

  const [getFaqs] = useLazyGetFaqsQuery()
  const [deleteFaq] = useDeleteFaqMutation()

  const [pagesCount, setPagesCount] = useState(1);
  const [filters, setFilters] = useState<FilterParams>({ limit: PARAMS.LIMIT, offset: PARAMS.OFFSET })

  const handleGetRequest = async () => {
    try {
      const responseFaqs = await getFaqs(filters).unwrap();

      dispatch(setFaqs(responseFaqs.faqs));
      setPagesCount(responseFaqs.count || 1)
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteFaq = async (id: string) => {
    try {
      if (!id) {
        return null
      }

      await deleteFaq({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  const handlePagination = (page: number, limit: number) => {
    const offset = page === 1 ? PARAMS.OFFSET : limit * (page - 1)

    setFilters({ limit, offset })
  }

  useEffect(() => {
    handleGetRequest()
  }, [filters])

  return {
    faqList,
    handleDeleteFaq,
    pagesCount,
    handlePagination
  }
}
